import React from 'react';
import { useTranslation } from 'react-i18next';
import { SpinnerIcon } from '../../icons';
import './ProgressStatusCard.scss';
export const ProgressStatusCard = () => {
    const { t } = useTranslation();
    return (React.createElement("div", { className: "progress-status-card" },
        React.createElement(SpinnerIcon, { width: 24, height: 24, fill: "#1890FF" }),
        React.createElement("div", { className: "progress-status-card__header" },
            React.createElement("p", { className: "progress-status-card__header__title" }, t('progress_status_card.title')),
            React.createElement("p", { className: "progress-status-card__header__description" }, t('progress_status_card.description')))));
};
//# sourceMappingURL=ProgressStatusCard.js.map